const ChevronRight = ({
	color = "#142D36",
	width = 6,
	height = 8,
	strokeWidth,
}: {
	color?: string;
	width?: number;
	height?: number;
	strokeWidth?: number;
}) => (
	<>
		<svg
			width={width}
			height={height}
			viewBox="0 0 6 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 1L5 5L1 9"
				stroke={color}
				strokeWidth={strokeWidth || 1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</>
);

export default ChevronRight;
